<template>
  <div class="m-5 p-5">
    <h1>{{ $t('noGroups:ohno') | capitalize }}</h1>
    <h2>{{ $t('noGroups:' + groups + 'Empty') | capitalize }}</h2>

    <div class="mt-5">
      <router-link v-if="isRole.admin" id="noGroupsAdminLink" :to="'/administration/' + groups">
        {{ $t('noGroups:' + groups + 'EmptyAdmin') | capitalize }}
      </router-link>
      <span v-else>{{ $t('noGroups:' + groups + 'EmptyNotAdmin') | capitalize }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // [fleets|clusters]
    groups: {
      type: String,
      required: true
    }
  }
}
</script>
